import RelatedEventsSection from "@/components/editor/shared/sections/related-events/related-events-section-component";

export default RelatedEventsSection;
